/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import clsx from "clsx";
import React, {memo} from "react";
import {createUseStyles} from "react-jss";
import MeltwaterLogo from "../assets/images/clients/meltwater-logo.svg";
import NhstMediaGroupLogo from "../assets/images/clients/nhst-media-group-logo.png";
import NttDocomoLogo from "../assets/images/clients/ntt-docomo-logo.svg";
import SoftbankLogo from "../assets/images/clients/softbank-logo.svg";
import UI from "./UI";
import {H2} from "./typography/Headings";
import Container from "./Container";

const useStyles = createUseStyles({
    root: {
        padding: "4rem 0",
        [UI.media.only("xs")]: {
            padding: "2rem 0"
        }
    },
    title: {
        textAlign: "center"
    },
    list: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexWrap: "wrap"
    },
    meltwater: {
        "& img": {
            height: 60,
            width: "auto"
        }
    },
    logo: {
        display: "block",
        maxWidth: 100,
        "& img": {
            maxWidth: 75
        },
        "& span": {
            borderRadius: 100,
            backgroundColor: UI.colors.veryLightGrey.toCSS()
        },
        [UI.media.only("xs")]: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            margin: ".5rem 0",
            padding: "0 .5rem",
            flex: "0 0 33.3333%",
            "& span": {
                display: "block",
                width: 75,
                height: 75
            }
        },
        [UI.media.gte("sm")]: {
            margin: ".5rem",
            "& span": {
                display: "block",
                width: 75,
                height: 75
            },
            "&:nth-child(1)": {
                marginLeft: 0
            },
            "&:nth-child(5)": {
                marginRight: 0
            },
            "&:nth-child(6)": {
                marginLeft: "auto"
            },
            "&:nth-child(9)": {
                marginRight: "auto"
            }
        },
        [UI.media.only("md")]: {
            margin: "1rem",
            "& img": {
                maxWidth: 100
            },
            "& span": {
                width: 100,
                height: 100
            }
        },
        [UI.media.only("lg")]: {
            margin: "1.4rem",
            "& img": {
                maxWidth: 125
            },
            "& span": {
                width: 125,
                height: 125
            }
        },
        [UI.media.only("xl")]: {
            margin: "1.625rem",
            "& img": {
                maxWidth: 169
            },
            "& span": {
                width: 169,
                height: 169
            }
        }
    }
});

interface CustomerProps {
    title: string;
}

function CustomerProps(props: CustomerProps) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Container>
                <H2 className={classes.title}>{props.title}</H2>

                <div className={classes.list}>
                    <div className={classes.logo}>
                        <img src={SoftbankLogo} alt="SoftBank" />
                    </div>
                    <div className={classes.logo}>
                        <img src={NhstMediaGroupLogo} alt="NHST Media Group" />
                    </div>
                    <div className={clsx(classes.logo, classes.meltwater)}>
                        <img src={MeltwaterLogo} alt="Meltwater" />
                    </div>
                    <div className={classes.logo}>
                        <img src={NttDocomoLogo} alt="NTT Docomo" />
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default memo(CustomerProps);
